import React, { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Card, Spinner } from "@/components/common";
import { studioApi, useStudio } from "./studioApi";

const GuardMessage = ({ denied = false }) => {
  const { t } = useStudio();
  return (
    <Card className="p-8 max-w-xl" data-testid="studio-guard-message">
      <h1 className="text-xl font-bold text-white">{t("Studio")}</h1>
      <p className="mt-2 text-sm text-gray-400">
        {denied ? t("Dieser Bereich ist nur für Super Admins zugänglich.") : t("Dieses Modul ist in dieser Umgebung nicht aktiv.")}
      </p>
    </Card>
  );
};

// Der Schluessel bindet diese Pruefung an genau ein Konto. Ein Kontowechsel
// entfernt die bisherige Ansicht sofort und startet wieder mit "loading".
function CheckedStudio({ children }) {
  const [state, setState] = useState("loading");
  useEffect(() => {
    let current = true;
    studioApi.status()
      .then(({ data }) => { if (current) setState(data?.enabled === true ? "ok" : "off"); })
      .catch(() => { if (current) setState("off"); });
    return () => { current = false; };
  }, []);

  if (state === "loading") return <Spinner />;
  return state === "ok" ? children : <GuardMessage />;
}

export default function StudioGuard({ children }) {
  const { user } = useAuth();
  const identity = user?.id || user?.email;
  if (user?.role !== "super_admin" || !identity) return <GuardMessage denied />;
  return <CheckedStudio key={identity}>{children}</CheckedStudio>;
}

